import { jsx as _jsx } from "react/jsx-runtime";
import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate, useSearchParams, } from 'react-router-dom';
import { getAppConfig, getSessionItem, setSessionItem, } from '~/services/application.service';
import { validateTokens } from '~/services/auth.service';
import { initAxios } from '~/services/http.service';
import { parseSessionData } from '~/services/utilities.service';
import { useAuth } from '~/hooks/useAuth';
const ProtectedLayout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const [authState, dispatch] = useAuth();
    const { environment } = getAppConfig();
    useEffect(() => {
        if (!authState.isAuthenticated && isLoading) {
            initAuth();
        }
    }, [authState.isAuthenticated, isLoading]);
    const getSessionData = () => {
        const requiredData = ['token', 'refreshToken', 'username', 'county'];
        const params = {};
        for (const key of Object.keys(sessionStorage)) {
            params[key] = getSessionItem(key);
        }
        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }
        requiredData.forEach((field) => {
            if (!params[field]) {
                throw new Error('not-authenticated');
            }
        });
        return params;
    };
    const initAuth = async () => {
        try {
            const sessionData = getSessionData();
            const { token, refreshToken, username, county } = sessionData;
            const { token: updatedToken, refreshToken: updatedRefreshToken } = await validateTokens(token, refreshToken);
            const payload = {};
            sessionData.token = updatedToken;
            sessionData.refreshToken = updatedRefreshToken;
            if (process.env.SENTRY_ENABLED === 'true' && username) {
                Sentry.setUser({ username, county });
            }
            for (const [key, value] of Object.entries(sessionData)) {
                setSessionItem(key, value);
                payload[key] = parseSessionData(value);
            }
            initAxios(navigate);
            dispatch({
                type: 'LOGIN',
                payload: {
                    isAuthenticated: true,
                    ...payload,
                },
            });
            setIsLoading(false);
        }
        catch (err) {
            setIsLoading(false);
            // TODO: add logging
            // console.log('error', err.message);
            sessionStorage.clear();
            return null;
        }
    };
    if (authState.isAuthenticated && isLoading) {
        setIsLoading(false);
        return null;
    }
    if (isLoading) {
        return null;
    }
    const RedirectRoute = environment.type !== 'PRODUCTION' ? (_jsx(Navigate, { state: { path: location.pathname }, to: "/login" })) : (_jsx(Navigate, { state: { path: location.pathname }, to: "/session-expired" }));
    return authState.isAuthenticated ? _jsx(Outlet, {}) : RedirectRoute;
};
export default ProtectedLayout;
